
import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, DataTableSkeleton, Pagination } from 'carbon-components-react';
import callGetApi from 'requests/GetRequests';
import * as Constants from '../../requests/URLConstants';
import QualityCheckTable from './QualityCheckTable';
import i18n from "../../i18n";

require("./_quality-check.scss");


const CompletedQualityCheck = props => {

    const [headers, setheaders] = useState([
        {
            key: 'check_name',
            header: i18n.t('qualityCode.Stage')
        }, {
            key: 'severity',
            header: i18n.t('qualityCode.Severity')
        }, {
            key: 'description',
            header: i18n.t('qualityCode.Description')
        }, {
            key: 'type',
            header: i18n.t('qualityCode.CompType')
        }, {
            key: 'categories',
            header: i18n.t('qualityCode.Category')
        }, {
            key: 'content',
            header: ''
        }
    ]);
    const [rows, setrows] = useState([]);
    const [loader, setloader] = useState(true);
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const home = i18n.t('qualityCode.Home');
    const qualityCheck = i18n.t('qualityCode.qualityCheck');
    const previousPage = i18n.t('qualityCode.Previouspage');
    const nextPage = i18n.t('qualityCode.nextPage');
    const Itemspage = i18n.t('qualityCode.Itemspage');
    const nodataavailable = i18n.t('qualityCode.Nodataavailable');

    useEffect(() => {
        getQualityCheckData();
    }, []);

    function addUniqueId(data) {
        data.forEach(function (element, index) {
            element.check_name = JSON.parse(element.check_name).stage_name;
            element.content = element.content.body;
            element.id = (index+1).toString();
        });
        return data;
    }

    useEffect(() => {
        setTotalItems(rows.length);
        getPaginatedRows(firstRowIndex,currentPageSize);
    }, [rows])

    function getPaginatedRows(param,pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = rows.slice(startingIndex,startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    }

    async function getQualityCheckData() {
        setloader(true);
        let uniqueData = [];
        await callGetApi(Constants.CODEQUALITYCHECKRESULT + props.location.id,
        { 'Content-Type': 'application/json' })
        .then(response => {
            if(response.length) {
                uniqueData = addUniqueId(response)
                setrows(uniqueData);
            }
            setloader(false);
        });
    }
    return (
        <div className="quality-check-container">
            <div className="quality-check-header">
                <div>
                    <Breadcrumb noTrailingSlash aria-label="Page navigation">
                        <BreadcrumbItem href='/homepage'>
                            {home}
                        </BreadcrumbItem>
                        <BreadcrumbItem href="/qualityCheck">
                            {qualityCheck}
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="title">
                        {props.location.requestId}
                    </div>
                </div>
            </div>
            <div className="quality-table">
            {loader ?
                <DataTableSkeleton
                    columnCount={headers.length}
                    rowCount={3}
                />
                :
                rows.length ?
                    <div>
                        <QualityCheckTable rows={paginatedRows} fullRows={rows} isExpandable={true}
                        headers={headers}
                        />
                        <Pagination
                            totalItems={totalItems}
                            backwardText={previousPage}
                            forwardText={nextPage}
                            pageSize={currentPageSize}
                            pageSizes={[5, 10, 15, 25]}
                            itemsPerPageText={Itemspage}
                            onChange={({ page, pageSize }) => {
                                let newFirstRowIndex = pageSize * (page - 1);
                                setFirstRowIndex(newFirstRowIndex)
                                getPaginatedRows(newFirstRowIndex,pageSize);
                            }}
                        />
                    </div>
                    :
                    <div className="center-align">
                       {nodataavailable}
                    </div>
                }
            </div>
        </div>
    );
};

export default CompletedQualityCheck;

